import Snackbar from '@material-ui/core/Snackbar/Snackbar';
import Alert from '@material-ui/lab/Alert/Alert';
import useAppAuth from 'packages/hooks/use-app-auth';
import useAppDispatch from 'packages/hooks/use-app-dispatch';
import useAppSelector from 'packages/hooks/use-app-selector';
import {Redirect} from 'react-router-dom';
import {selectToast, triggerToast} from 'redux/features/app-slice';
import useStyles from './admin-styles';
import Content from './content/Content';
import Navigation from './navigation/Navigation';
import SubHeader from './sub-header/SubHeader';

const Admin = () => {
  const classes = useStyles();
  const dispatch = useAppDispatch();
  const toast = useAppSelector(selectToast);
  const {authenticated, isAdmin} = useAppAuth();

  const handleCloseSnackbar = () => {
    dispatch(
      triggerToast({
        isOpen: false,
      })
    );
  };

  if (authenticated && !isAdmin) return <Redirect to="/app" />;
  if (!authenticated && !isAdmin) return <Redirect to="/" />;
  // if (auth && !auth.isAdmin) return <Redirect to="/app" />;

  return (
    <>
      <Snackbar
        open={toast?.isOpen}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
      >
        <Alert onClose={handleCloseSnackbar} severity={toast?.type}>
          {toast?.message}
        </Alert>
      </Snackbar>
      <div className={classes.ad_root}>
        <SubHeader />
        <Navigation />
        <Content />
      </div>
    </>
  );
};

export default Admin;
